import React from 'react'
import './ATHeaderText.css'

interface ATHeaderTextProps {
  title: string
  children: React.ReactElement | null
  borderRequired?: boolean | null | undefined
}

const ATHeaderText: React.FC<ATHeaderTextProps> = ({
  title,
  children,
  borderRequired = true,
}) => {
  const getClassName = () => {
    let baseClass =
      'header-text text-left py-2 d-flex justify-content-between align-items-center'
    if (borderRequired) {
      baseClass = `${baseClass} border-bottom`
    }
    return baseClass
  }

  return (
    <div className={getClassName()}>
      {title && <p className="left-align-text header-bold m-0">{title}</p>}
      {children}
    </div>
  )
}

export default ATHeaderText
